export var Environment;
(function (Environment) {
    Environment["Development"] = "development";
    Environment["Production"] = "production";
})(Environment || (Environment = {}));
//# sourceMappingURL=Environment.js.map